import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { parseDate } from 'react-day-picker/moment';
const moment = extendMoment(Moment);

export function getAdminModifiers(overrides, calendars, bookings) {
  let dates = [];
  overrides.filter(x => x.availability === "Unavailable").map(x => dates.push(parseDate(moment(x.date))));

  let reservedDates = getReservedDatesFromiCal(calendars, true, true);
  let cwBookings = getBookingDates(bookings, 'cw', true, true);

  let cwCheckins = cwBookings.filter(d => d.checkin === true).map(d => parseDate(d.date));
  let cwCheckouts = cwBookings.filter(d => d.checkout === true).map(d => parseDate(d.date));

  let otherCheckins = reservedDates.filter(d => d.checkin === true).map(d => parseDate(d.date));
  let otherCheckouts = reservedDates.filter(d => d.checkout === true).map(d => parseDate(d.date));

  return ({
    cw: cwBookings.map(d => parseDate(d.date)),
    airbnb: reservedDates.filter(d => d.type === 'airbnb').map(d => parseDate(d.date)),
    vrbo: reservedDates.filter(d => d.type === 'vrbo').map(d => parseDate(d.date)),
    other: reservedDates.filter(d => d.type === 'other').map(d => parseDate(d.date)),
    unavailable: dates,
    overrides: overrides,
    cwcheckin: cwCheckins,
    cwcheckout: cwCheckouts,
    checkin: otherCheckins,
    checkout: otherCheckouts
  });
}

export function getBookingModifiers(overrides, calendars, bookings) {
  let dates = [];
  overrides.filter(x => x.availability === "Unavailable").map(x => dates.push(parseDate(moment(x.date))));
  dates = bookings.length > 0 ? dates.concat(getBookingDates(bookings, null, true, false)) : dates;

  dates = calendars.length > 0 ? dates.concat(getReservedDatesFromiCal(calendars, true, false)) : dates;
  dates = dates.concat({ before: new Date() });
  return ({
    disabled: dates,
    overrides: overrides.filter(x => x.availability === "Available"),
  })
}

export function dateRange(startDate, endDate) {
  let range = moment.range(moment(startDate), moment(endDate));
  return Array.from(range.snapTo('day').by('day'));
}

function getBookingDates(bookings, type, includeStart, includeEnd) {
  let bookedDates = [];
  bookings.map(b => {
    let range = moment.range(moment(b.startDate), moment(b.endDate));
    let dateArray = Array.from(range.snapTo('day').by('day'));
    if (!includeStart) {
      dateArray = dateArray.slice(1);
    }
    if (!includeEnd) {
      dateArray = dateArray.slice(0, -1);
    }
    bookedDates = bookedDates.concat(dateArray.map((d, i) => {
      return (type) ? { type: type, date: d, checkin: i === 0, checkout: i === dateArray.length - 1 } : parseDate(d)
    }));
  });
  return bookedDates;
}

function getReservedDatesFromiCal(calendars, includeStart, includeEnd) {
  let reservedDates = [];
  calendars.map(cal => {
    reservedDates = (cal.data)
      ? parseCalendarIntoDateArray(cal.data, reservedDates, cal.type, includeStart, includeEnd)
      : parseCalendarIntoDateArray(cal, reservedDates, null, includeStart, includeEnd);
  });
  return reservedDates;
}

const dateArrayMap = (d, i, type, dateArray) => {
  return (type) ? {
    type: type,
    date: d,
    checkin: i === 0,
    checkout: i === dateArray.length - 1
  } : parseDate(d)
}

function parseCalendarIntoDateArray(cal, reservedDates, type, includeStart, includeEnd) {
  for (var event in cal) {
    if (!cal.hasOwnProperty(event))
      continue;

    let e = cal[event];
    if (!e.start || !e.end)
      continue;

    let range = moment.range(moment(e.start), moment(e.end));
    let dateArray = Array.from(range.by('day'));

    if (!includeStart) {
      dateArray = dateArray.slice(1);
    }
    if (!includeEnd) {
      dateArray = dateArray.slice(0, -1);
    }

    reservedDates = reservedDates.concat(dateArray.map((d, i) => dateArrayMap(d, i, type, dateArray)));
  }

  return reservedDates;
}
